import type { SceneNode } from "../scene/model";
import { hasEffects } from "../native/effects";
import { isInteractive } from "../native/interactive";

export function needsDisplayRaster(node: SceneNode) {
  return (
    hasEffects(node) ||
    !!node.layer.clipToBelow ||
    node.kind === "text" ||
    node.kind === "path" ||
    isInteractive(node)
  );
}

const equal = (a: unknown, b: unknown) =>
  a === b || JSON.stringify(a) === JSON.stringify(b);

/** A style edit can retain its sharp previous pixels while the replacement is prepared.
 * Geometry/source changes still need a current preview, not an old object in the wrong place. */
export function sameRasterLayout(
  before: SceneNode | undefined,
  after: SceneNode | undefined,
): boolean {
  if (!before || !after) return before === after;
  return (
    before.id === after.id &&
    before.kind === after.kind &&
    equal(before.transform, after.transform) &&
    equal(before.geometry, after.geometry) &&
    equal(before.text, after.text) &&
    equal(before.media, after.media) &&
    equal(before.interaction, after.interaction) &&
    before.layer.clipToBelow === after.layer.clipToBelow
  );
}
